import React, {
  Dispatch,
  SetStateAction,
  useState,
  useEffect,
  useContext,
} from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Table,
  Form,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import { ThemeContext } from "../../helpers/themeContext";
import {
  UPDATE_AUTOMATION,
  GET_ALL_USERS,
  GET_INBOXES,
  GET_ORGANISATIONS,
  GET_RESPONSE_DETAILS,
  GET_RESPONSE_KEYWORDS,
  GET_USERS,
} from "./query";
import SweetAlert from "react-bootstrap-sweetalert";
import client from "../../apollo";
import { toNumber } from "lodash";
import {
  KEYWORD_ANYWHERE,
  KEYWORD_ONLY,
  KEYWORD_WORD,
  PHRASE,
  PHRASEEXACT,
} from "./helper";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { setResellerId } from "src/apollo/link";

interface IProps {
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
  refresh: any;
  selectedResponse: any;
}
interface APIAccount {
  APIAccountId: number;
  Name: string;
}

const EditBotAutomation = (props: IProps) => {
  const toggle = () => {
    props.setModal(!props.modal);
  };

  const [organisations, setOrganisations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState<number>(-1);
  const [APIAccounts, setAPIAccounts] = useState<APIAccount[]>([]);
  const [selectedAPIAccount, setSelectedAPIAccount] = useState<number>(-1);
  const [loading, setLoading] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [failure_dlg, setfailure_dlg] = useState(false);
  const Theme = useContext(ThemeContext);
  const [dynamic_description, setdynamic_description] = useState("");
  const [keyword, setKeyword] = useState("");
  const [reply, setReply] = useState("");
  const [responseTypeOptions, setResponseTypeOptions] = useState([
    {
      label: "Reply",
      value: 1,
    },
    {
      label: "Assign",
      value: 2,
    },
    {
      label: "Route",
      value: 3,
    },
  ]);
  const [responseType, setResponseType] = useState<any>(responseTypeOptions[0]);
  const [routeType, setRouteType] = useState<any>();
  const [routeTypeOptions, setRouteTypeOptions] = useState<any[]>();
  const [matchTypeOptions, setMatchTypeOptions] = useState([
    {
      value: KEYWORD_ONLY,
      label: "Keyword Only",
    },
    {
      value: KEYWORD_ANYWHERE,
      label: "Keyword Anywhere",
    },
    {
      value: KEYWORD_WORD,
      label: "Keyword as word",
    },
    {
      value: PHRASE,
      label: "Phrase",
    },
    {
      value: PHRASEEXACT,
      label: "Exact Phrase",
    },
  ]);
  const [matchType, setMatchType] = useState<any>(matchTypeOptions[0]);
  const [featureOptions, setFeatureOptions] = useState([
    {
      label: "None",
      value: 0,
    },
    {
      label: "Quick Reply",
      value: 1,
    },
    {
      label: "List",
      value: 2,
    },
  ]);
  const [featureType, setFeatureType] = useState<any>(0);
  const [automationEnabledOptions, setAutomationEnabledOptions] = useState([
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ]);
  const [automationEnabled, setAutomationEnabled] = useState(0);
  const [automationRepliesOptions, setAutomationRepliesOptions] = useState([
    { value: 0, label: "No" },
    { value: 1, label: "Yes" },
  ]);
  const [automationRepliesEnabled, setAutomationRepliesEnabled] = useState(0);
  const [assignee, setAssignee] = useState<any>(null);
  const [assigneeOptions, setAssigneeOptions] = useState<any[]>();
  const [quickReplyOptions, setQuickReplyOptions] = useState([
    { value: 1, label: "Button 1 Text", textValue: "" },
    { value: 2, label: "Button 2 Text", textValue: "" },
    { value: 3, label: "Button 3 Text", textValue: "" },
  ]);
  const [listOptions, setListOptions] = useState([
    { value: 1, label: "List Item 1", textValue: "" },
    { value: 2, label: "List Item 2", textValue: "" },
    { value: 3, label: "List Item 3", textValue: "" },
    { value: 4, label: "List Item 4", textValue: "" },
    { value: 5, label: "List Item 5", textValue: "" },
    { value: 6, label: "List Item 6", textValue: "" },
    { value: 7, label: "List Item 7", textValue: "" },
    { value: 8, label: "List Item 8", textValue: "" },
    { value: 9, label: "List Item 9", textValue: "" },
    { value: 10, label: "List Item 10", textValue: "" },
  ]);

  const [initialValues, setInitialValues] = useState<any>(null);

  const [updateAutomation] = useMutation(UPDATE_AUTOMATION);

  const [triggerRespQuery, { data, loading: loadingData, error }] =
    useLazyQuery(GET_RESPONSE_DETAILS);

  useEffect(() => {
    if (props.selectedResponse) {
      triggerRespQuery({
        variables: { responseId: props.selectedResponse.Id },
      }).then(res => {
        const result = res.data.msgbox_BotResponse[0];
        console.log(result, `< res`);

        // Always set org + account + core fields first
        setSelectedOrg(result.Organisation.OrganisationId);
        setSelectedAPIAccount(result.APIAccount.APIAccountId);
        setKeyword(result.Keyword);
        setReply(result.Reply);

        // Determine response type
        let responseTypeValue = 1;
        let assigneeValue = null;
        if (
          typeof result.RouteTo === "number" &&
          result.AssignTo === null &&
          result.AssignToDepartment === null
        ) {
          responseTypeValue = 3;
          assigneeValue = result.RouteTo;
        } else if (
          result.AssignTo &&
          result.RouteTo === null &&
          result.AssignToDepartment === null
        ) {
          responseTypeValue = 2;
          assigneeValue = result.AssignTo;
        } else if (
          result.AssignToDepartment &&
          result.AssignTo === null &&
          result.RouteTo === null
        ) {
          responseTypeValue = 2;
          assigneeValue = result.AssignToDepartment;
        }

        setResponseType(responseTypeValue);
        setAssignee(assigneeValue);
        setMatchType(result.BotResponseType);

        // -------- FEATURE TYPE HANDLING --------
        let newFeatureType = 0;
        let newQuickReplyOptions = [...quickReplyOptions];
        let newListOptions = [...listOptions];

        if (result.ReplyMetadata === null && result.ListMetadata === null) {
          newFeatureType = 0;
        }

        if (result.ReplyMetadata && result.ListMetadata === null) {
          newFeatureType = 1; // Quick Reply
          const buttons = JSON.parse(result.ReplyMetadata);
          newQuickReplyOptions = newQuickReplyOptions.map((b, i) => ({
            ...b,
            textValue: buttons[i]?.title || "",
          }));
        }

        if (result.ListMetadata && result.ReplyMetadata === null) {
          newFeatureType = 2; // List feature
          const lists = JSON.parse(result.ListMetadata);
          const listItems = lists[0]?.options || [];
          newListOptions = newListOptions.map((b, i) => ({
            ...b,
            textValue: listItems[i]?.title || "",
          }));
        }

        // Now set updated feature-related state
        setFeatureType(newFeatureType);
        setQuickReplyOptions(newQuickReplyOptions);
        setListOptions(newListOptions);

        // -------- ROUTE TO SETUP (for edit) --------
        let routeTypeValue = null;
        if (responseTypeValue === 3 && result.Folder && result.RouteTo) {
          routeTypeValue = {
            inbox: {
              name: result.Folder.Inbox.Name,
              id: result.Folder.Inbox.InboxId,
            },
            folderId: result.RouteTo,
          };
          setRouteType(routeTypeValue);
        }

        // -------- SAVE SNAPSHOT --------
        setInitialValues({
          selectedOrg: result.Organisation.OrganisationId,
          selectedAPIAccount: result.APIAccount.APIAccountId,
          keyword: result.Keyword,
          reply: result.Reply,
          responseType: responseTypeValue,
          routeType: routeTypeValue,
          assignee: assigneeValue,
          matchType: result.BotResponseType,
          featureType: newFeatureType,
          quickReplyOptions: newQuickReplyOptions,
          listOptions: newListOptions,
        });
      });
    }
  }, [props.selectedResponse]);

  useEffect(() => {
    loadOrgs();
  }, []);

  useEffect(() => {
    if (responseType === 3) {
      loadInboxes();
    }
  }, [responseType]);

  const loadInboxes = async () => {
    const response = await client.query({
      query: GET_INBOXES,
      variables: { apiAccountId: selectedAPIAccount },
    });
    const options:
      | React.SetStateAction<string>
      | {
          label: string;
          value: { inbox: { name: any; id: any }; folderId: any };
        }[] = [];
    response.data.msgbox_Inbox.forEach(
      (inbox: {
        APIAccount: { Name: any; APIAccountId: any };
        Folders: any[];
        Name: string;
        InboxId: any;
      }) => {
        if (inbox.APIAccount.APIAccountId === selectedAPIAccount) {
          inbox.Folders.forEach(folder => {
            options.push({
              label: inbox.Name + " " + `(${folder.Name})`,
              value: {
                inbox: {
                  name: inbox.Name,
                  id: inbox.InboxId,
                },
                folderId: folder.FolderId,
              },
            });
          });
        }
      }
    );
    if (routeType === null || routeType === undefined) setRouteType(options[0]);

    setRouteTypeOptions(options);
  };

  useEffect(() => {
    const fullOrg: any = organisations.filter(
      (order: any, key: number) => order["OrganisationId"] == selectedOrg
    );
    if (fullOrg.length === 0) return;
    setAPIAccounts(fullOrg[0].APIAccounts);
  }, [selectedOrg]);

  const loadOrgs = async () => {
    const orgs = await client.query({
      query: GET_ORGANISATIONS,
    });
    const orgData = orgs?.data?.msgbox_Organisation || [];
    const orgId = orgData[0]["OrganisationId"];
    setOrganisations(orgData);
    setSelectedOrg(orgId);
    const apiId = orgData[0].APIAccounts[0]?.APIAccountId;
    setSelectedAPIAccount(apiId);
  };

  const handleOrgSelect = async (target: number) => {
    setSelectedOrg(target);
  };

  const handleAPIAccountSelect = async (target: number) => {
    setSelectedAPIAccount(target);
  };

  const handleResponseTypeSelect = async (target: number) => {
    setResponseType(target);
  };

  const handleRouteTypeSelect = async (target: any) => {
    const parsedValue = JSON.parse(target);
    setRouteType(parsedValue);
  };

  const handleMatchTypeSelect = async (target: any) => {
    setMatchType(target);
  };

  const handleFeatureTypeSelect = async (target: number) => {
    setFeatureType(target);
  };

  useEffect(() => {
    if (selectedAPIAccount) fetchUsers();
  }, [selectedAPIAccount]);

  const fetchUsers = async () => {
    const orgUsers = await client.query({
      query: GET_USERS,
      fetchPolicy: "no-cache",
      variables: { orgId: selectedOrg },
    });
    const users = await client.query({
      query: GET_ALL_USERS,
      fetchPolicy: "no-cache",
    });

    const options = [];
    orgUsers?.data?.msgbox_Organisation[0]?.Departments?.filter(
      (d: { DepartmentInboxes: any[] }) => {
        if (d.DepartmentInboxes.length == 0) return true;
        let arr = d.DepartmentInboxes.filter((i: { InboxId: number }) => {
          return i.InboxId == selectedAPIAccount;
        });
        return arr.length > 0 ? true : false;
      }
    ).forEach(
      (department: {
        UserDepartments: any[];
        Name: any;
        DepartmentId: any;
      }) => {
        if (department.UserDepartments.length > 0) {
          // Add the users to the dropdown
          const group = {
            label: department.Name,
            options: department.UserDepartments.map(user => ({
              label: user.User.FirstName + " " + user.User.LastName,
              value: {
                type: "user",
                value: user.User.UserId,
              },
            })),
          };
          // Add the department
          group.options.push({
            label: `Assign to team (${department.Name})`,
            value: {
              type: "department",
              value: department.DepartmentId,
            },
          });
          options.push(group);
        }
      }
    );
    const usersNotInATeam = users.data.msgbox_User
      .filter(
        (user: { UserDepartments: string | any[] }) =>
          user.UserDepartments.length < 1
      )
      .map((user: { UserId: any; FirstName: any; LastName: any }) => ({
        value: { type: "user", value: user.UserId },
        label: `${user.FirstName} ${user.LastName}`,
      }));
    options.push({
      label: "Users not in a team",
      options: usersNotInATeam,
    });

    setAssignee(options[0].options[0] || null);
    setAssigneeOptions(options);
  };

  const handleSubmit = async () => {
    setLoading(true);

    let ReplyMetaData = null;
    let ListMetaData = null;

    // Build ReplyMetaData
    if (featureType === 1) {
      const replies = quickReplyOptions
        .filter(b => b.textValue.trim() !== "")
        .map((b, i) => ({
          postbackText: `postback-${i + 1}`,
          type: "text",
          title: b.textValue.trim(),
        }));
      if (replies.length > 0) ReplyMetaData = JSON.stringify(replies);
    }

    // Build ListMetaData
    if (featureType === 2) {
      const listItems = listOptions
        .filter(b => b.textValue.trim() !== "")
        .map(b => ({
          postbackText: `${b.textValue} payload`,
          type: "text",
          title: b.textValue.trim(),
        }));
      if (listItems.length > 0)
        ListMetaData = JSON.stringify([
          { title: "Select An Option", options: listItems },
        ]);
    }

    try {
      await updateAutomation({
        variables: {
          responseId: props.selectedResponse.Id,
          orgId: selectedOrg,
          //  keyword: keyword.trim(),
          reply,
          assignTo:
            responseType === 2 && assignee.type === "user"
              ? assignee.value
              : null,
          assignToDepartment:
            responseType === 2 && assignee.type === "department"
              ? assignee.value
              : null,
          routeTo: responseType === 3 ? routeType.folderId : null,
          account: selectedAPIAccount,
          matchType,
          isEnabled: automationEnabled === 1,
          ListMetaData,
          ReplyMetaData,
        },
      });

      setLoading(false);
      setdynamic_description("Automation updated successfully!");
      setsuccess_dlg(true);
      props.setModal(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      setdynamic_description("Error updating automation");
      setfailure_dlg(true);
      props.refresh();
    }
  };

  return (
    <React.Fragment>
      {success_dlg ? (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      {failure_dlg ? (
        <SweetAlert
          error
          title={Theme.name}
          onConfirm={() => {
            setfailure_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <Modal isOpen={props.modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle} tag="h4">
          Edit Bot Automation
        </ModalHeader>
        <ModalBody className="modelStyle">
          <AvForm
            onValidSubmit={() => {
              handleSubmit();
            }}
          >
            <Row form className="d-flex flex-row mb-3">
              <Col>
                <FormGroup className="mb-3">
                  <Label>Select an Organisation</Label>
                  <Input
                    disabled={true}
                    className="avInput"
                    id="selectOrg"
                    name="selectOrg"
                    type="select"
                    value={selectedOrg}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleOrgSelect(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(organisations)
                      ? organisations.map((order: any, key: number) => (
                          <option key={key} value={order["OrganisationId"]}>
                            {order["Name"]}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Select an API Account</Label>
                  <Input
                    disabled={true}
                    className="avInput"
                    id="selectAPIAccount"
                    name="selectAPIAccount"
                    type="select"
                    value={selectedAPIAccount}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleAPIAccountSelect(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(APIAccounts)
                      ? APIAccounts.map((order: any, key: number) => (
                          <option key={key} value={order["APIAccountId"]}>
                            {order["Name"]}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Response Type*</Label>
                  <Input
                    className="avInput"
                    id="selectResponseType"
                    name="selectResponseType"
                    type="select"
                    value={responseType}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleResponseTypeSelect(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(responseTypeOptions)
                      ? responseTypeOptions.map((order: any, key: number) => (
                          <option key={key} value={order.value}>
                            {order.label}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>

                {responseType === 2 && (
                  <FormGroup className="mb-3">
                    <Label>Assignee*</Label>
                    <Input
                      className="avInput"
                      id="selectAssignee"
                      name="selectAssignee"
                      type="select"
                      value={JSON.stringify(assignee)} // must be string if using objects
                      onChange={(e: React.FormEvent<HTMLInputElement>) => {
                        try {
                          const parsedValue = JSON.parse(e.currentTarget.value);
                          setAssignee(parsedValue);
                        } catch (err) {
                          console.error("Invalid JSON:", err);
                        }
                      }}
                    >
                      {Array.isArray(assigneeOptions)
                        ? assigneeOptions.map((group: any, key: number) => (
                            <React.Fragment key={key}>
                              <option disabled style={{ fontSize: 18 }}>
                                {group.label}
                              </option>
                              {group.options.map(
                                (teamOption: any, idx: number) => (
                                  <option
                                    key={idx}
                                    value={JSON.stringify(teamOption.value)} // stringify the object
                                  >
                                    {teamOption.label}
                                  </option>
                                )
                              )}
                            </React.Fragment>
                          ))
                        : null}
                    </Input>
                  </FormGroup>
                )}

                {responseType === 3 && (
                  <FormGroup className="mb-3">
                    <Label>Route to*</Label>
                    <Input
                      className="avInput"
                      id="selectRouteTo"
                      name="selectRouteTo"
                      type="select"
                      value={JSON.stringify(routeType)}
                      onChange={(e: React.FormEvent<HTMLInputElement>) => {
                        handleRouteTypeSelect(e.currentTarget.value);
                      }}
                    >
                      {Array.isArray(routeTypeOptions)
                        ? routeTypeOptions.map((order: any, key: number) => (
                            <option
                              key={key}
                              value={JSON.stringify(order.value)}
                            >
                              {order.label}
                            </option>
                          ))
                        : null}
                    </Input>
                  </FormGroup>
                )}

                <FormGroup className="mb-3">
                  <Label>Match Type*</Label>
                  <Input
                    className="avInput"
                    id="selectMatchType"
                    name="selectMatchType"
                    type="select"
                    value={matchType}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleMatchTypeSelect(e.currentTarget.value);
                    }}
                  >
                    {Array.isArray(matchTypeOptions)
                      ? matchTypeOptions.map((order: any, key: number) => (
                          <option key={key} value={order.value}>
                            {order.label}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Feature*</Label>
                  <Input
                    className="avInput"
                    id="selectFeature"
                    name="selectFeature"
                    type="select"
                    value={featureType}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      handleFeatureTypeSelect(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(featureOptions)
                      ? featureOptions.map((order: any, key: number) => (
                          <option key={key} value={order.value}>
                            {order.label}
                          </option>
                        ))
                      : null}
                  </Input>
                </FormGroup>
              </Col>

              <div
                style={{
                  width: 20,
                }}
              ></div>

              <Col>
                <FormGroup className="mb-3">
                  <Label>Keyword*</Label>
                  <Input
                    className="textInput"
                    value={keyword}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      setKeyword(e.currentTarget.value);
                    }}
                  ></Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Reply *</Label>
                  <Input
                    className="textInput"
                    id="selectReply"
                    name="selectReply"
                    type="textarea"
                    style={{ height: 206 }}
                    value={reply}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      setReply(e.currentTarget.value);
                    }}
                  ></Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Automation Enabled</Label>
                  <Input
                    className="avInput"
                    id="automationEnabled"
                    name="automationEnabled"
                    type="select"
                    value={automationEnabled}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      setAutomationEnabled(toNumber(e.currentTarget.value));
                    }}
                  >
                    {Array.isArray(APIAccounts)
                      ? automationEnabledOptions.map(
                          (order: any, key: number) => (
                            <option key={key} value={order.value}>
                              {order.label}
                            </option>
                          )
                        )
                      : null}
                  </Input>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Automation Replies Enabled</Label>
                  <Input
                    className="avInput"
                    id="automationRepliesEnabled"
                    name="automationRepliesEnabled"
                    type="select"
                    value={automationRepliesEnabled}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      setAutomationRepliesEnabled(
                        toNumber(e.currentTarget.value)
                      );
                    }}
                  >
                    {Array.isArray(APIAccounts)
                      ? automationRepliesOptions.map(
                          (order: any, key: number) => (
                            <option key={key} value={order.value}>
                              {order.label}
                            </option>
                          )
                        )
                      : null}
                  </Input>
                </FormGroup>
              </Col>

              {featureType !== 0 && (
                <>
                  <div
                    style={{
                      width: 20,
                    }}
                  ></div>

                  {featureType === 1 && (
                    <Col>
                      {/* 3 button text boxes - 1,2, ns 3 
                        1 COL       */}

                      {quickReplyOptions.map((button, index) => {
                        return (
                          <FormGroup className="mb-3" key={button.value}>
                            <Label>{button.label}</Label>

                            <Input
                              className="textInput"
                              id={`${button.label}`}
                              name={`${button.label}`}
                              type="textarea"
                              //style={{ height: 206 }}
                              value={button.textValue}
                              onChange={(
                                e: React.FormEvent<HTMLInputElement>
                              ) => {
                                const newValue = e.currentTarget.value;
                                setQuickReplyOptions(prev =>
                                  prev.map((b, i) =>
                                    i === index
                                      ? { ...b, textValue: newValue }
                                      : b
                                  )
                                );
                              }}
                            ></Input>
                          </FormGroup>
                        );
                      })}
                    </Col>
                  )}
                  {featureType === 2 && (
                    <>
                      <Col>
                        {/* 10 List item text boxes - list item 1, 2... 10 
                        2 COLS - 5 each
                        */}
                        {listOptions.map((listOption, index) => {
                          if (listOption.value > 5) return null;
                          else {
                            return (
                              <FormGroup
                                className="mb-3"
                                key={listOption.value}
                              >
                                <Label>{listOption.label}</Label>
                                <Input
                                  className="textInput"
                                  id={`${listOption.label}`}
                                  name={`${listOption.label}`}
                                  type="textarea"
                                  //style={{ height: 206 }}
                                  value={listOption.textValue}
                                  onChange={(
                                    e: React.FormEvent<HTMLInputElement>
                                  ) => {
                                    const newValue = e.currentTarget.value;
                                    setListOptions(prev =>
                                      prev.map((b, i) =>
                                        i === index
                                          ? { ...b, textValue: newValue }
                                          : b
                                      )
                                    );
                                  }}
                                ></Input>
                              </FormGroup>
                            );
                          }
                        })}
                      </Col>
                      <div
                        style={{
                          width: 20,
                        }}
                      ></div>
                      <Col>
                        {listOptions.map((listOption, idx) => {
                          if (listOption.value <= 5) return null;
                          else {
                            return (
                              <FormGroup
                                className="mb-3"
                                key={listOption.value}
                              >
                                <Label>{listOption.label}</Label>
                                <Input
                                  className="textInput"
                                  id={`${listOption.label}`}
                                  name={`${listOption.label}`}
                                  type="textarea"
                                  //style={{ height: 206 }}
                                  value={listOption.textValue}
                                  onChange={(
                                    e: React.FormEvent<HTMLInputElement>
                                  ) => {
                                    const newValue = e.currentTarget.value;
                                    setListOptions(prev =>
                                      prev.map((b, i) =>
                                        i === idx
                                          ? { ...b, textValue: newValue }
                                          : b
                                      )
                                    );
                                  }}
                                ></Input>
                              </FormGroup>
                            );
                          }
                        })}
                      </Col>
                    </>
                  )}
                </>
              )}
            </Row>
            <Row>
              <Col>
                {!loading ? (
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-light w-sm"
                      onClick={() => {
                        if (initialValues) {
                          setSelectedOrg(initialValues.selectedOrg);
                          setSelectedAPIAccount(
                            initialValues.selectedAPIAccount
                          );
                          setKeyword(initialValues.keyword);
                          setReply(initialValues.reply);
                          setResponseType(initialValues.responseType);
                          setRouteType(initialValues.routeType);
                          setAssignee(initialValues.assignee);
                          setMatchType(initialValues.matchType);

                          // Restore dependents first
                          setQuickReplyOptions(initialValues.quickReplyOptions);
                          setListOptions(initialValues.listOptions);

                          // Then restore featureType *afterwards*
                          setFeatureType(initialValues.featureType);
                        }

                        props.setModal(false);

                        props.refresh();
                      }}
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-success save-user">
                      Save
                    </button>
                  </div>
                ) : (
                  <div className="text-end">
                    <button type="button" className="btn btn-light w-sm">
                      Loading
                    </button>
                  </div>
                )}
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default EditBotAutomation;
